import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notes-modal__patient-context" }
const _hoisted_2 = {
  key: 0,
  class: "notes-modal__requirement-notice"
}
const _hoisted_3 = {
  key: 1,
  class: "notes-modal__optional-notice"
}
const _hoisted_4 = { class: "notes-modal__hipaa-notice" }

import { ref, computed, watch } from 'vue'

interface Props {
  modelValue: boolean
  callWasAccepted: boolean
  sessionId: string
  existingNotes?: string
  patientName: string
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
  (e: 'notes-saved', notes: string): void
  (e: 'notes-skipped'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotesModal',
  props: {
    modelValue: { type: Boolean },
    callWasAccepted: { type: Boolean },
    sessionId: {},
    existingNotes: {},
    patientName: {}
  },
  emits: ["update:modelValue", "notes-saved", "notes-skipped"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const notesText = ref('')
const isSaving = ref(false)
const errorMessage = ref('')

const modalTitle = computed(() => {
  return props.existingNotes ? 'Edit Notes' : 'Add Notes'
})

// Initialize notes text when dialog opens
watch(() => props.modelValue, (newValue) => {
  if (newValue) {
    notesText.value = props.existingNotes || ''
    errorMessage.value = ''
    isSaving.value = false
  }
})

const handleSkip = () => {
  if (props.callWasAccepted) {
    errorMessage.value = 'Notes are required for calls that were answered'
    return
  }
  emit('notes-skipped')
  emit('update:modelValue', false)
}

const handleSave = async () => {
  if (props.callWasAccepted && notesText.value.trim().length === 0) {
    errorMessage.value = 'Please enter notes for this call'
    return
  }

  isSaving.value = true
  try {
    emit('notes-saved', notesText.value.trim())
    emit('update:modelValue', false)
  } catch (err) {
    errorMessage.value = 'Failed to save notes. Please try again.'
    isSaving.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "600",
    persistent: "",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "notes-modal" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "notes-modal__title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(modalTitle.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "notes-modal__content" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[2] || (_cache[2] = _createTextVNode(" Call with ", -1)),
                _createElementVNode("strong", null, _toDisplayString(__props.patientName), 1)
              ]),
              (__props.callWasAccepted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_icon, {
                      color: "info",
                      size: "small",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-information", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[4] || (_cache[4] = _createElementVNode("span", null, "This call was answered - notes are required for documentation", -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_v_icon, {
                      color: "grey",
                      size: "small",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("mdi-information-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "Optional: Add notes if needed", -1))
                  ])),
              _createVNode(_component_v_textarea, {
                modelValue: notesText.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((notesText).value = $event)),
                variant: "outlined",
                label: "Call notes",
                placeholder: "Enter notes about this call (e.g., patient concerns, follow-up actions, observations)",
                rows: "6",
                counter: "2000",
                maxlength: 2000,
                "error-messages": errorMessage.value,
                class: "notes-modal__textarea mt-4"
              }, null, 8, ["modelValue", "error-messages"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_icon, {
                  color: "warning",
                  size: "small",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-shield-alert", -1)
                  ]))]),
                  _: 1
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-caption" }, " Do not include patient identifiable information (PHI) such as names, MRNs, or dates of birth ", -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "notes-modal__actions" }, {
            default: _withCtx(() => [
              (!__props.callWasAccepted)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "text",
                    color: "grey",
                    onClick: handleSkip
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" Skip ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "elevated",
                disabled: __props.callWasAccepted && notesText.value.trim().length === 0,
                loading: isSaving.value,
                onClick: handleSave
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.existingNotes ? 'Update Notes' : 'Save Notes'), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})